import { module } from 'modujs';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
        this.init();
    }

    init() {
        const element = this.el;
        const rightContent = document.getElementById('right-content');
        let leftFinished = false; 

        
        gsap.set(element, {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 10
        });

        
         gsap.to(element, {
            scrollTrigger: {
                trigger: element,
                start: "top top",
                end: "bottom top",
                scrub: true,
                once: true,
                onEnter: () => {
                    gsap.fromTo(element, { y: -100 }, { y: 0, duration: 2, ease: "power2.out" });
                },
                onLeave: () => {                
                    leftFinished = true;
                    gsap.set(element, {
                        width: "50vw",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        height: "100vh",
                        zIndex: 10
                    });
                    gsap.set(rightContent, {
                        y: 0,
                        clearProps: "transform",
                        height: "auto"
                    });
                },
                markers: false,
            },
            width: "50vw",
        });

        
        ScrollTrigger.create({
            trigger: element,
            start: "top top",
            end: "bottom top",
            scrub: true,
            onUpdate: (self) => {
                if (leftFinished) return; 
                const progress = self.progress;
                gsap.to(rightContent, {
                    y: `${progress * 100}vh`,
                    duration: 0.0001,
                    ease: "power2.out",
                });
            },
            markers: true,
        });
    }
}
